// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__OnaqM","buttons":"SendReceipts_buttons__3QBRg","email":"SendReceipts_email__3W8h4","bookApptTitle":"SendReceipts_bookApptTitle__2vFY0"};